const barcodeOptions = {
  format: 'CODE128',
  height: 40,
  width: 1.865,
  displayValue: false
}
export const getBarcodeOptionsByDigit = (digit, mode) => {
  let width
  let margin = 10
  if (digit > 13) {
    // 16
    width = 1.75
  } else if (digit > 10) {
    // 13
    width = 2
  } else {
    // 預留的，目前沒做到這
    // 10
    width = 2.275
  }
  if (mode === 'big') {
    margin = 0
    if (digit > 13) {
      width = 1.35
    } else if (digit > 10) {
      width = 1.625
    }
  }
  return { ...barcodeOptions, width, margin }
}
